export enum PaymentState {
  NotStarted,
  WaitingPayment,
  Success,
  Failed,
}
